// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"343":"02a5e7e03fb41eb2","935":"726eb804d4057c2a","6869":"113cda77a697b7b1","8226":"723d83f19b77d8d2"}[chunkId] + ".css";
};